import './index.css';
import { jsx } from 'react/jsx-runtime';
import { BaseText } from './BaseText.js';
import 'classnames';
import './base-text-DqfkG6Rh.js';

const Text = ({ Element = 'div', style = 'primary', typography = 'paragraph-2-regular', ...restProps }) => {
    return jsx(BaseText, { Element: Element, style: style, typography: typography, ...restProps });
};

export { Text };
//# sourceMappingURL=Text.js.map
